import { isRequired } from '../../utils.js';

const mode = _ref => {
  let {
    win
  } = _ref;
  if (win.matchMedia('screen and (max-width:51.9rem)').matches) {
    return 'mobile';
  }
  return 'desktop';
};

/**
 * NOTE: `user_agent` is part of the schema but is intentionally left out as this value is inserted
 * by the pixiedust endpoint on the backend.
 */
var commonWebClientMetadata = (_ref2 => {
  let {
    page_edition = isRequired('page_edition')
  } = _ref2;
  return () => {
    // frameElement will return value if it is from within iframe on same domain.  In that case,
    //  use that as the window to synchronize values
    const win = window.frameElement ? window.parent : window;
    return {
      mode: mode({
        win
      }),
      page_edition,
      viewport_size: {
        width: Number(win.screen.width),
        height: Number(win.screen.height)
      }
    };
  };
});

export default commonWebClientMetadata;
